import styled from 'styled-components'
import { COLOR } from '../../design/color/color.constants'
import { SPACING } from '../../design/spacing/spacing.constants'
import { FONT_SIZE, FONT_BOLD } from '../../design/typography/typography.constants'
import { ReactComponent as PickupPin } from './assets/location-start.svg'
import { ReactComponent as DropoffPin} from './assets/location.svg'

const iconHeightWidth = '24px'
const iconPinMarginRight = SPACING.S
const iconRightMarginLeft = SPACING.XS

const iconStyles = `
  background-color: ${COLOR.WHITE};
  margin-right: ${iconPinMarginRight};
  flex-grow: 0;
  flex-shrink: 0;
  width: ${iconHeightWidth};
`

const PickupPinIcon = styled(PickupPin)`
  ${iconStyles}
`

const DropoffPinIcon = styled(DropoffPin)`
  ${iconStyles}
`

const WaypointTrailStyles = `
  content: '';
  position: absolute;
  top: 50%;
  bottom: 4px;
  left: 11px;
  border-left-width: 2px;
  border-left-style: dashed;
  border-left-color: ${COLOR.BLACK};
  z-index: -1;
`

const WaypointTitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-bottom: ${props => (props.hasCaption ? SPACING.S : 0)};

  &:before{
    ${WaypointTrailStyles}
    top: ${props => (props.isDestination || props.isStopover) && '0'};
    bottom: ${props => props.isDestination && '50%'};
  }
`

const WaypointTitle = styled.div`
  flex-grow: 1;
  max-width: ${props => (props.hasIcon
    ? `calc(100% - ${iconHeightWidth} - ${iconPinMarginRight} - ${iconHeightWidth} - ${iconRightMarginLeft})`
    : `calc(100% - ${iconHeightWidth} - ${iconPinMarginRight})`)
  }
`

const WaypointCaption = styled.span`
  ${FONT_BOLD};
  font-size: ${FONT_SIZE.MEDIUM};
`

const WaypointIconRight = styled.div`
  display: flex;
  align-items: center;
  width: ${iconHeightWidth};
  height: ${iconHeightWidth};
  margin-left: ${iconRightMarginLeft};
  flex-shrink: 0;
  cursor: pointer;
  & > * {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
`

const WaypointContentWrapper = styled.div`
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  &:before{
    ${WaypointTrailStyles}
    top: 0;
    ${props => props.isDestination && 'border: none'}
  }

  padding-left: 39px;
  padding-bottom: ${props => (props.isDestination ? 0 : SPACING.M)};
  padding-right: ${props => (props.hasIconRight ? `calc(${iconRightMarginLeft} + ${iconHeightWidth})` : 0)};
`

const WaypointWrapper = styled.div`
  position: relative;

  ${WaypointTitleWrapper}{
    background: ${props => (props.isDragging ? 'white' : 'none')};
    opacity: ${props => (!props.draggingOver && props.isDragging ? 0.3 : 1)};
    &:before{
      display: ${props => (props.isDragging ? 'none' : 'block')};
    }
  }

  ${WaypointContentWrapper}{
    background: ${props => (props.isDragging ? 'white' : 'none')};
    opacity: ${props => (!props.draggingOver && props.isDragging ? 0.3 : 1)};
    &:before{
      display: ${props => (props.isDragging ? 'none' : 'block')};
    }
  }
`

export {
  WaypointWrapper,
  WaypointTitleWrapper,
  WaypointTitle,
  WaypointCaption,
  WaypointIconRight,
  WaypointContentWrapper,
  PickupPinIcon,
  DropoffPinIcon,
}
